import cx from 'clsx';
import type React from 'react';

type Props = {
  className?: string;
  icon: React.ReactNode;
  badge: string | number | null;
  color?: 'default' | 'red';
} & React.InputHTMLAttributes<HTMLDivElement>;

export const IconBadge: React.FC<Props> = ({ className, icon, badge, color = 'default', ...otherProps }) => {
  return (
    <div className={cx('relative cursor-pointer', className)} {...otherProps}>
      {icon}
      {badge && (
        <span
          className={cx(
            'absolute top-[-5px] right-[-5px] flex size-5 place-content-center place-items-center rounded-full font-bold text-white',
            color === 'red' ? 'bg-red-dark' : 'bg-sky-400',
          )}
        >
          {badge}
        </span>
      )}
    </div>
  );
};
